import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  TextField,
  Snackbar,
  Alert,
  useTheme,
  AppBar,
  Toolbar,
  IconButton,
  Container,
} from "@mui/material";
import { Navigate, useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import logofw from "../img/logo-fw.png";
import LoginIcon from "@mui/icons-material/Login";
import CreateUser from "../api/user/CreateUser";
import { tokens } from "../components/Theme";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { InputAdornment } from "@mui/material";
function Registeration() {
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [showPassword, setShowPassword] = useState(false);
  const toggleShowPassword = () => setShowPassword((prev) => !prev);
  function ResponsiveAppBar() {
    return (
      <AppBar
        position="static"
        sx={{ backgroundColor: colors.greenAccent[400] }}
      >
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <img
                src={logofw}
                width={isMobile ? "60px" : "80px"}
                alt="logo"
                draggable={false}
                style={{
                  objectFit: "contain",
                  userSelect: "none",
                  pointerEvents: "none",
                }}
              />

              <IconButton edge="end" onClick={() => navigate("/login")}>
                <LoginIcon sx={{ color: "#fff" }} />
              </IconButton>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    );
  }

  const [form, setForm] = useState({
    mobileNo: "",
    password: "",
    idCard: "",
    level:"0",
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

    const handleSubmit = async () => {
    const { mobileNo, password, idCard } = form;
    if (!mobileNo || !password || !idCard) {
      setSnackbar({
        open: true,
        message: "กรุณากรอกข้อมูลที่จำเป็นให้ครบ",
        severity: "error",
      });
      return;
    }else{
    const response = await CreateUser(form);
    if (response === 200) {
      setSnackbar({
        open: true,
        message: "สมัครสมาชิกสำเร็จ!",
        severity: "success",
      });
      setTimeout(() => {
        navigate("/login");
      }, 1500);
    } else {
      setSnackbar({
        open: true,
        message: "บัญชีนี้เคยลงทะเบียนแล้ว",
        severity: "error",
      });
    }
  }
  };

  return (
    <Box>
      <ResponsiveAppBar />
      <Box
        sx={{
          maxWidth: 400,
          mx: "auto",
          mt: 5,
          p: 3,
          borderRadius: 2,
          boxShadow: isMobile ? "none" : 3,
          backgroundColor: "#fff",
        }}
      >
        <Typography variant="h5" mb={2}>
          สมัครสมาชิก
        </Typography>


        <TextField
          label="เบอร์โทรศัพท์"
          name="mobileNo"
          required
          value={form.mobileNo}
          onChange={handleChange}
          fullWidth
          sx={{ mb: 2 }}
        />
        <TextField
          label="เลขบัตรประชาชน"
          name="idCard"
          required
          value={form.idCard}
          onChange={handleChange}
          fullWidth
          sx={{ mb: 2 }}
        />
<TextField
  label="รหัสผ่าน"
  type={showPassword ? "text" : "password"}
  name="password"
  required
  value={form.password}
  onChange={handleChange}
  fullWidth
  sx={{ mb: 2 }}
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        <IconButton onClick={toggleShowPassword} edge="end">
          {showPassword ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      </InputAdornment>
    ),
  }}
/>


        <Button
          variant="contained"
          fullWidth
          onClick={handleSubmit}
          sx={{ mt: 2, backgroundColor: colors.greenAccent[400] }}
        >
          สมัครสมาชิก
        </Button>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
        </Snackbar>
      </Box>
    </Box>
  );
}

export default Registeration;
